import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Divider,
  Button,
  Card,
  CardContent,
  TextField,
  CardHeader,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  FormControl,
  ButtonGroup,
  Menu,
  Snackbar,
  Alert
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import React, { Component } from 'react';
import { _axios } from 'src/plugins/axios';
import * as _ from 'lodash';
import commonService from 'src/service/common';
import goodalipi from 'src/plugins/goodalipi';
import axios from 'axios';
import moment from 'moment';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';

class PhsMisData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      limit: 5,
      selectedMonth: 'Current Months Data',
      isMisData: false,
      misData: [],
      columnsToShow: [
        'PatientName',
        'CorporateName',
        'MobileNumber',
        'EmailId',
        'EmployeeId',
        'Age',
        'Gender',
        'Relation',
        'OrderId',
        'AppointmentBookedDate',
        'AppointmentDate',
        'AppointmentStatus',
        'AppointmentMonth',
        'Package',
        'PackageType',
        'Provider',
        'DCID',
        'Location',
        'City',
        'State',
        'VisitType',
        'ConfirmationDate',
        'ReportUploadDate',
        'CouponSharedDate',
        'ConfirmationTAT',
        'ReportUplaodTAT',
        'GMV_With_GST',
        'GMV_Without_GST',
        'FeedbackLinkSharedDate',
        'Remarks',
        'OverallRating'
      ],
      totalCount: 0,
      exportType: 'xlsx',
      months: ['Current Month Data', 'Previous Month Data'],
      anchorEl: null,
      loading: false,
      showSnack: false,
      snackMsg: '',
      snackType: 'info'
    };
  }

  handleClose = async (item) => {
    this.setState({ anchorEl: null });
    if (item) {
      this.setState({ exportType: item.title });
    }
  };

  getPhsMisData = async () => {
    this.setState({ isMisData: false });
    let payLoad = {
      startIndex: this.state.page * this.state.limit,
      pageSize: this.state.limit,
      month:
        this.state.selectedMonth == 'Previous Month Data'
          ? new Date().getMonth()==0 ? 12 : new Date().getMonth()
          : new Date().getMonth() + 1
    };
    _axios
      .post('ahc/misData', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        if (res.data && res.data.isSuccess) {
          this.setState({ isMisData: true });
          this.setState({ misData: res.data.result });
          this.setState({ totalCount: res.data.totalCount });
        }
      });
    console.log(payLoad);
  };

  componentDidMount() {
    this.getPhsMisData();
  }

  handleLimitChange = async (event) => {
    await this.setState({ limit: event.target.value });
    this.getPhsMisData();
  };

  handlePageChange = async (event, newPage) => {
    await this.setState({ page: newPage });
    this.getPhsMisData();
  };
  exportFile = async (filetype) => {
    this.setState({
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info'
    });
    let payLoad = {
      fileType: this.state.exportType,
      month:
        this.state.selectedMonth == 'Previous Month Data'
          ? new Date().getMonth()==0 ? 12 : new Date().getMonth()
          : new Date().getMonth() + 1
    };
    this.downloadMIS(payLoad);
  };

  downloadMIS = async (payload) => {
    _axios
      .post(
        'ahc/misData',
        {
          service: 1,
          ...payload
        },
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        }
      )
      .then((response) => {
        if (
          response.data &&
          response.data.isSuccess &&
          response.data.preSignedUrl
        ) {
          this.downloadFile(response.data.preSignedUrl);
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded successfully!',
            snackType: 'success'
          });
        } else if (response.data && !response.data.isSuccess) {
          this.setState({
            loading: false,
            showSnack: true,
            snackMsg: 'File downloaded failed!',
            snackType: 'error'
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error'
        });
      });
  };

  downloadProviderList(){
    _axios
    .post('ahc/providerlist')
    .then((response) => {
      if (
        response.data &&
        response.data.isSuccess &&
        response.data.preSignedUrl
      ) {
        this.downloadFile(response.data.preSignedUrl);
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success'
        });
      } else if (response.data && !response.data.isSuccess) {
        this.setState({
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error'
        });
      }
    })
    .catch((error) => {
      this.setState({
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error'
      });
    });
  }

  downloadFile = async (url) => {
    var link = document.createElement('a');
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  render() {
    const fileList = [
      {
        id: 'CSV',
        title: 'csv'
      },
      {
        id: 'XLSX',
        title: 'xlsx'
      }
    ];
    const open = Boolean(this.state.anchorEl);
    return (
      <>
        <Helmet>
          <title>PHS | MIS</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container alignItems="stretch" spacing={2}>
              <Grid item container lg={12} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <Grid
                    marginTop="0%"
                    marginBottom="5%"
                    container
                    direction="row"
                    justifyContent="space-around"
                    spacing={3}
                  >
                    <FormControl
                      sx={{ m: 1 }}
                      size="small"
                      variant="outlined"
                      required
                    >
                      <Select
                        required
                        value={this.state.selectedMonth}
                        onChange={(ev) => {
                          this.setState({ selectedMonth: ev.target.value });
                        }}
                        renderValue={(selected) => selected}
                        label="Location"
                      >
                        {this.state.months.map((val, idx) => (
                          <MenuItem
                            sx={{ py: 0 }}
                            value={val}
                            key={idx}
                            name={val}
                          >
                            <ListItemText primary={val} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Button
                      sx={{
                        width: '20%',
                        height: '5%',
                        boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                        backgroundColor: '#143a72',
                        color: 'white',
                        marginTop: '5px'
                      }}
                      onClick={() => {
                        this.getPhsMisData();
                      }}
                    >
                      Fetch Data
                    </Button>
                    <ButtonGroup
                      variant="text"
                      disabled={false}
                      sx={{
                        width: '180px',
                        boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                        borderRadius: 15,
                        height: '40px',
                        marginTop: '5px'
                      }}
                    >
                      <Button
                        sx={{ px: 2 }}
                        onClick={() => this.exportFile(this.state.exportType)}
                        startIcon={<ExportIcon size="18" />}
                      >
                        Export
                      </Button>
                      <Button
                        onClick={(e) =>
                          this.setState({ anchorEl: e.currentTarget })
                        }
                        endIcon={<ArrowDropDownIcon />}
                      >
                        {this.state.exportType}
                      </Button>
                    </ButtonGroup>
                    <Menu
                      id="export-menu"
                      open={open}
                      anchorEl={this.state.anchorEl}
                      onClose={() => this.handleClose()}
                      MenuListProps={{
                        'aria-labelledby': 'exporttypeMenu'
                      }}
                    >
                      {fileList.map((menu) => (
                        <MenuItem
                          key={menu.id}
                          onClick={() => this.handleClose(menu)}
                        >
                          {menu.title}
                        </MenuItem>
                      ))}
                    </Menu>
                    <Button
                    onClick={()=>{
                      this.downloadProviderList()
                    }}
                      sx={{
                        marginTop: '5px',
                        color: 'black',
                        height: '5%',
                        boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                        backgroundColor: '#143a72',
                        color: 'white',
                      }}
                    >
                      Click Here to get Provider List
                    </Button>
                  </Grid>
                  <hr />
                  <b style={{ marginLeft: '45%' }}>MIS Data</b>
                  <hr />
                  {!this.state.isMisData ? (
                    <CircularProgress
                      sx={{ margin: '20%', marginLeft: '40%' }}
                      size={100}
                    />
                  ) : (
                    <TableContainer>
                      <Table
                        stickyHeader
                        aria-label="MIS Data"
                        id="employee-list"
                      >
                        <TableHead>
                          <TableRow>
                            {this.state.columnsToShow.map((item) => {
                              return <TableCell>{item}</TableCell>;
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.misData.map((e) => (
                            <TableRow>
                              <TableCell>{e.Name ? e.Name : 'NA'}</TableCell>
                              <TableCell>
                                {e.CorporateName ? e.CorporateName : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ContactNo ? e.ContactNo : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.EmailId ? e.EmailId : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.EmployeeId ? e.EmployeeId : 'NA'}
                              </TableCell>
                              <TableCell>{e.Age ? e.Age : 'NA'}</TableCell>
                              <TableCell>
                                {e.Gender ? e.Gender : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.RelationShip ? e.RelationShip : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.orderid ? e.orderid : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.appoitmnentBookedDate
                                  ? moment(e.appoitmnentBookedDate).format(
                                      'DD-MM-YYYY'
                                    )
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ApptDate
                                  ? moment(e.ApptDate).format('DD-MM-YYYY')
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.AppointmentStatus
                                  ? e.AppointmentStatus
                                  : 'NA'}
                              </TableCell>
                              <TableCell>{e.Month ? e.Month : 'NA'}</TableCell>
                              <TableCell>
                                {e.PackageName ? e.PackageName : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.payment ? e.payment : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.DCName ? e.DCName : 'NA'}
                              </TableCell>
                              <TableCell>{e.DCID ? e.DCID : 'NA'}</TableCell>
                              <TableCell>
                                {e.Location ? e.Location : 'NA'}
                              </TableCell>
                              <TableCell>{e.city ? e.city : 'NA'}</TableCell>
                              <TableCell>{e.state ? e.state : 'NA'}</TableCell>
                              <TableCell>
                                {e.VisitType ? e.VisitType : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ConfirmationDate
                                  ? moment(e.ConfirmationDate).format(
                                      'DD-MM-YYYY'
                                    )
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ReportUploadDate
                                  ? moment(e.ReportUploadDate).format(
                                      'DD-MM-YYYY'
                                    )
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ReportUploadDate
                                  ? moment(e.ReportUploadDate).format(
                                      'DD-MM-YYYY'
                                    )
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.confirmationTAT ? e.confirmationTAT : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ReportuplaodTAT ? e.ReportuplaodTAT : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.GMV_with_GST
                                  ? e.GMV_with_GST.toFixed(2)
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.GMV_without_GST
                                  ? e.GMV_without_GST.toFixed(2)
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.ReportUploadDate
                                  ? moment(e.ReportUploadDate).format(
                                      'DD-MM-YYYY'
                                    )
                                  : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.remarks ? e.remarks : 'NA'}
                              </TableCell>
                              <TableCell>
                                {e.OverallRating ? e.OverallRating : 'NA'}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <TablePagination
                        component="div"
                        count={this.state.totalCount}
                        onPageChange={this.handlePageChange}
                        onRowsPerPageChange={this.handleLimitChange}
                        page={this.state.page}
                        rowsPerPage={this.state.limit}
                        rowsPerPageOptions={[5, 10, 25]}
                      />
                    </TableContainer>
                  )}
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Snackbar
            open={this.state.showSnack}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={4000}
            onClose={() => this.setState({ showSnack: false })}
          >
            <Alert
              onClose={() => this.setState({ showSnack: false })}
              severity={this.state.snackType}
            >
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
      </>
    );
  }
}

export default PhsMisData;
